import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { MetadataSection } from "~/molecules/DocumentMetadataSections";

const descriptionMaxLength = 300;

interface Props {
  description: string | null;
}

export default function WorkflowDescription({ description }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <MetadataSection title={t(($) => $.commons.workflow.description)}>
      {description ? (
        <>
          <div className="text-xs whitespace-pre-wrap">
            {expanded || description.length < descriptionMaxLength
              ? description
              : `${description.slice(0, descriptionMaxLength).trim()}...`}
          </div>
          {description.length > descriptionMaxLength ? (
            <div className="flex justify-center">
              <Button variant="link" onClick={() => setExpanded(!expanded)}>
                {expanded
                  ? t(($) => $.commons.buttons.collapse)
                  : t(($) => $.commons.buttons.expand)}
              </Button>
            </div>
          ) : null}
        </>
      ) : (
        <p className="text-muted-foreground text-sm">-</p>
      )}
    </MetadataSection>
  );
}
